import { ILineMetaNewFunnel } from '../interfaces';
import {
  IMeasureControl,
  QueryType,
} from '../../../utils/apollo/graphqlSchema';
import { assertNotNil } from '../../../utils/types';
import { findByKey } from '../../../utils/redux/util';
import {
  getMeasureColorFromColorConfig,
  IAnalysisColorConfig,
} from './analysisColorConfig';
import { getMeasureLabel } from '../ChartContext/utils';
export interface IParsedFunnelSliceModeMeasure {
  name: string;
  color: string;
  measureKey: string;
  label: string;
}

export const getFunnelSliceModeMeasures = (
  lineMeta: ILineMetaNewFunnel[1],
  measureControls: IMeasureControl[],
  colorConfig: IAnalysisColorConfig,
): IParsedFunnelSliceModeMeasure[] => {
  const funnelModeSlice = lineMeta.funnelModeSlice;
  assertNotNil(funnelModeSlice);
  return [funnelModeSlice.firstMeasureKey, funnelModeSlice.lastMeasureKey].map(
    (measureKey) => {
      const color = getMeasureColorFromColorConfig(colorConfig, measureKey);
      const name = findByKey(measureControls, measureKey).name;
      // only looking for label in funnel, therefore isResultKey and hasResultMeasure are false
      const label = getMeasureLabel(
        QueryType.Funnel,
        measureControls.findIndex((mc) => mc.key === measureKey),
        false,
        false,
      );
      return { color, name, measureKey, label };
    },
  );
};
